(function ($) {
    $(document).ready(function () {
        let radioButtonTwo = $('.accordionRadioButtonTwo').val();
        const accordionPageReload = '.accordion-page-reload';
        const accordionRadioBtnTarget = '.accordion-radio-btn';
        const contentActive = 'vds-form__conditional-content--active';
        const itemRemoved = 'vds-item-removed';
        const optionOneContentTarget = '.accordion-radio-option-one';
        const optionTwoContentTarget = '.accordion-radio-option-two';
        const radioButtonsTarget = '.accordion-radio-btns';
        const speed = 500;
        const top = 0;

        $(document).on('click', accordionPageReload, function () {
            $('html, body').animate({scrollTop: top}, speed, function() {
                location.reload();
            });
        });

        $(accordionRadioBtnTarget).on('click',function() {
            let $form = $(this).closest('.vds-form');
            let radioBtnsDiv = $form.find(radioButtonsTarget);
            let accordionDiv;
            if ($(this).val() === radioButtonTwo) {
                accordionDiv = $form.find(optionTwoContentTarget);
            } else {
                accordionDiv = $form.find(optionOneContentTarget);
            }
            radioBtnsDiv.addClass(itemRemoved);
            accordionDiv.addClass(contentActive);
        });
    });
})(window.jQuery);
